module.exports = {
  getLocalStorageCheckoutKey: (store) => `checkouts::${store}`,
  getLocalStorageConsentKey: (store) => `consentGranted::${store}`,
  // don't want to use redux to get the store (impacts performance)
  // so I set it to stoxsocks
  getLocalStorageSegmentUserIdentifyKey: () =>
    `segmentUserIdentified::stoxsocks`,
  getSessionStorageCurrencyUpdatedKey: (store) => `currencyUpdated::${store}`,
  getSessionStorageSizeVariantKey: () => `sizeVariants::stoxsocks`,
  getSessionStorageSessionStartedKey: () => 'sessionStarted',
  getPathname: (locale, slug) => `/${locale}/${slug ? `${slug}/` : ''}`,
  getAvailable: ({ availableInCountry }) => availableInCountry !== false,
  getDiscountPercentage: (discountPrice, originalPrice) => {
    if (!discountPrice && !originalPrice) {
      return null
    }

    const needle = ((originalPrice - discountPrice) * 100) / originalPrice

    const discounts = [15, 20, 25, 50]
    const closest = discounts.reduce(function (prev, curr) {
      return Math.abs(curr - needle) < Math.abs(prev - needle) ? curr : prev
    })

    return `${closest}%`
  },
  camelize: (str) =>
    str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
        index === 0 ? word.toLowerCase() : word.toUpperCase(),
      )
      .replace(/\s+/g, '')
      .replace('-', ''),
  capitalise: (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  },
  getSegmentWriteKey: (locale) => {
    switch (locale) {
      case 'en-US':
        return process.env.GATSBY_SEGMENT_WRITE_KEY_US
      default:
        return process.env.GATSBY_SEGMENT_WRITE_KEY_INTL
    }
  },
  getSegmentAnonymousIdKey: () => {
    return 'segmentAnonymousId'
  },
  getSegmentAnonymousId: () => {
    try {
      return document.cookie
        ?.split(';')
        ?.filter((str) => str.split('=')[0].includes('ajs_anonymous_id'))[0]
        ?.split('=')[1]
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err)
      return ''
    }
  },
  getKlaviyoListId: (locale) => {
    switch (locale) {
      case 'en-US':
        return 'W2p6yK'
      default:
        return 'JysQzY'
    }
  },
  getKlaviyoPublicApiKey: (locale) => {
    switch (locale) {
      case 'en-US':
        return 'TmSTtg'
      default:
        return 'aGSqbu'
    }
  },
  getCurrentStore: (node_locale) => {
    switch (node_locale) {
      case 'en-GB':
        return 'stox-uk'
      case 'en-US':
        return 'stox-usa'
      default:
        return 'stoxsocks'
    }
  },
  getShopifyData: (data = {}, locale) => {
    let extension = ''
    switch (locale) {
      case 'en-US':
        extension = 'Us'
        break
      default:
        break
    }

    return data[`shopifyData${extension}`] ?? {}
  },
  getDeviceType: () => {
    const ua = navigator.userAgent
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
      return 'tablet'
    }
    if (
      /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
        ua,
      )
    ) {
      return 'mobile'
    }
    return 'desktop'
  },
  getCookieKeyfbp: () => {
    return 'cookie_fbp'
  },
  getCookieKeyfbc: () => {
    return 'cookie_fbc'
  },
  getCookieValue: (name) => {
    return (
      document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() ||
      ''
    )
  },
  // sometimes users gets a fbclid query param when redirected from Facebook, this can be used as the _fbc tracking value if the cookie doesn't work
  getFbc: () => {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const fbc = urlParams.get('fbclid')
    const timestamp = Date.now() // Date.now() returns a unix timestamp in milliseconds

    return `fb.1.${timestamp}.${fbc}`
  },
}
